export default {
  table: {
    en: "Table",
    pt: "Tabela",
  },
  transitionTables: {
    AFNDLambda: {
      en: "NDFA-λ",
      pt: "AFND-λ",
    },
    clousure: {
      en: "Clousure-λ",
      pt: "Fecho-λ",
    },
    AFND: {
      en: "NDFA",
      pt: "AFND",
    },
    AFD: {
      en: "DFA",
      pt: "AFD",
    },
  },
  minimizationHeader: [
    { en: "Index", pt: "Indice" },
    { en: "D[i,j]", pt: "D[i,j]" },
    { en: "S[i,j]", pt: "S[i,j]" },
    { en: "Reason", pt: "Motivo" },
  ],
  info: {
    transitionAFNDLamdaToAFND: {
      en: "The transition table NDFA-λ to NDFA is complete",
      pt: "A tabela de transição AFND-λ → AFND está completa",
    },
    transitionAFNDToAFD: {
      en: "The transition table NDFA to NDA is complete",
      pt: "A tabela de transição AFND → AFD está completa",
    },
    notGoBack: {
      en: "It not possible to return",
      pt: "Não é possível voltar",
    },
    minimizationTable: {
      en: "Finished the verification step of final and non-final states.",
      pt: "Finalizada a etapa de verificação de estados finais e não finais.",
    },
  },
  buttons: {
    next: {
      en: "next",
      pt: "próximo",
    },
    previous: {
      en: "previous",
      pt: "anterior",
    },
    algorithm: {
      en: "Applied Algorithm",
      pt: "Algoritmo aplicado",
    },
  },
};
